//
//
//
//
//
//
//
//
//
//
//

import { queryNoticeDetail } from '@/https/user'

export default {

  data () {
    return {
      notice: { },
      attachList: [],
    }
  },

  computed: {},

  created () {
    this.setDetail()
  },

  methods: {
    async setDetail () {
      const { data } = await queryNoticeDetail({ wid: this.$route.query.wid })
      this.notice = data || {}
      this.notice.noticeAbs = `发布时间：${data?.createTime || ''}`
      this.attachList = data.fjList.map((el) => {
        return {
          url: el.fjdz,
          filename: el.fjmc,
        }
      })
    },
  },
}
